import {useSelector} from 'react-redux';

import {userSelector, isUnderLimit} from 'entities/user';

import {httpMonitorAPI} from '../api/httpMonitorAPI';


const useCanCreateHttpMonitor = (): boolean => {
    const user = useSelector(userSelector);

    const {data: summaryMonitors} = httpMonitorAPI.useGetSummaryHttpMonitorsQuery();

    return isUnderLimit(user?.tariff.monitor_max_count_limit, summaryMonitors?.total_active);
};

export default useCanCreateHttpMonitor;
